/**
 * Rotes Prestige-III-Theme (NT-PRESTIGE-02).
 *
 * Setzt `data-theme-prestige="rot"` auf <html>, wenn der Spieler Prestige III hat UND das Theme
 * eingeschaltet ist. Die Farben selbst liegen ausschließlich in design-tokens.css.
 */
import { gameState } from '../state/gameState.js';

/** Spiegel von prestige.constants.ts::PRESTIGE_THEME_MIN_RANK. */
export const PRESTIGE_THEME_MIN_RANK = 3;

/** Reine Logik: ist das Theme für diesen Spielerzustand aktiv? */
export function isPrestigeThemeActive(player: { prestigeRank?: number; prestigeTheme?: boolean } | null): boolean {
  if (player === null) return false;
  return (player.prestigeRank ?? 0) >= PRESTIGE_THEME_MIN_RANK && player.prestigeTheme === true;
}

export function applyPrestigeTheme(): void {
  const root = document.documentElement;
  if (isPrestigeThemeActive(gameState.getPlayer())) {
    root.dataset.themePrestige = 'rot';
  } else {
    delete root.dataset.themePrestige;
  }
}

/** Einmalig beim App-Start: hält das Attribut mit dem Spielerzustand synchron. */
export function initPrestigeTheme(): void {
  gameState.on('player:updated', applyPrestigeTheme);
  gameState.on('auth:logout', applyPrestigeTheme);
  applyPrestigeTheme();
}
